import { render, staticRenderFns } from "./ProductEmptyList.vue?vue&type=template&id=5b8fa25c"
import script from "./ProductEmptyList.vue?vue&type=script&lang=js"
export * from "./ProductEmptyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports